// Ruoli utente (utenti.id_ruolo), condivisi tra backend (gate e regole di accesso)
// e frontend (visibilita' della UI, che e' solo comodita': il confine reale e' il server).
export const RUOLI = {
  ADMIN: 0,
  PROPRIETARIO: 1,
  TECNICO: 2,
} as const;

// Chi puo' gestire i firmware dei tracker (caricare, rilasciare, assegnare,
// eliminare). I Proprietari mai. I permessi verranno rivisti: tenere qui l'unica regola.
export const RUOLI_GESTIONE_FIRMWARE: number[] = [RUOLI.ADMIN, RUOLI.TECNICO];

// Chi può creare, modificare ed eliminare i tipi di allarme del catalogo (Anagrafiche > Allarmi). I clienti non vedono nemmeno la pagina.
export const RUOLI_GESTIONE_ALLARMI: number[] = [RUOLI.ADMIN, RUOLI.TECNICO];

/** Vero se `idRuolo` è uno dei ruoli esistenti (0 admin, 1 cliente, 2 tecnico). */
export function ruoloValido(idRuolo: unknown): boolean {
  if (idRuolo === null || idRuolo === undefined || idRuolo === "") return false;
  return (Object.values(RUOLI) as number[]).includes(Number(idRuolo));
}
